/**
 * Premium Footer
 * Vanilla JS for mobile accordion and interactions
 */

class PremiumFooter extends HTMLElement {
  constructor() {
    super();
    this.accordionEnabled = this.dataset.mobileAccordion === 'true';
    this.blocks = [];

    if (this.accordionEnabled && window.matchMedia('(max-width: 749px)').matches) {
      this.initAccordion();
    }

    window.addEventListener('resize', () => {
      if (this.accordionEnabled && window.matchMedia('(max-width: 749px)').matches) {
        if (this.blocks.length === 0) this.initAccordion();
      } else {
        this.destroyAccordion();
      }
    });
  }

  initAccordion() {
    this.blocks = Array.from(this.querySelectorAll('.footer-block--link_list'));

    this.blocks.forEach((block) => {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;

      heading.setAttribute('role', 'button');
      heading.setAttribute('aria-expanded', 'false');
      heading.setAttribute('tabindex', '0');
      heading.addEventListener('click', () => this.toggleBlock(block));
      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleBlock(block);
        }
      });
    });
  }

  destroyAccordion() {
    this.blocks.forEach((block) => {
      const heading = block.querySelector('.footer-block__heading');
      if (!heading) return;

      heading.removeAttribute('role');
      heading.removeAttribute('aria-expanded');
      heading.removeAttribute('tabindex');
      heading.replaceWith(heading.cloneNode(true));
      block.classList.remove('is-open');
    });
    this.blocks = [];
  }

  toggleBlock(block) {
    const isOpen = block.classList.contains('is-open');
    const heading = block.querySelector('.footer-block__heading');

    if (isOpen) {
      block.classList.remove('is-open');
      heading.setAttribute('aria-expanded', 'false');
    } else {
      block.classList.add('is-open');
      heading.setAttribute('aria-expanded', 'true');
    }
  }
}

customElements.define('premium-footer', PremiumFooter);
